module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "test-container"
  }, [_c('div', {
    staticClass: "swiper-container dib"
  }, [_c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-box",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.content), function(item, index) {
    return (index) ? _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "slide-detail",
      class: 'slide' + index
    }, [_c('div', {
      staticClass: "slide-item-title"
    }, [_c('img', {
      staticClass: "title-icon dib",
      attrs: {
        "src": require("../../assets/img/supplier/use-ico.png"),
        "alt": item.title
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "title-text dib"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "slide-item-divider dib"
    }), _vm._v(" "), _c('div', {
      staticClass: "slide-item-content"
    }, [_vm._v("\n        " + _vm._s(item.desc) + "\n        ")])])]) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "select-list dib"
  }, [_c('div', {
    staticClass: "select-line dib"
  }), _vm._v(" "), _c('ul', {
    staticClass: "select-tree tl dib"
  }, _vm._l((_vm.content), function(item, index) {
    return (index) ? _c('li', {
      staticClass: "select-item dib",
      class: index === _vm.swipeIndex ? 'is-active' : '',
      on: {
        "mouseenter": function($event) {
          return _vm.changeSwiper(index)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('h1', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.title))])]) : _vm._e()
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon dib"
  }, [_c('div', {
    staticClass: "circle-outside"
  }, [_c('div', {
    staticClass: "circle-inside"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-376b8486"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/swiper.vue
// module id = 404
// module chunks = 12